import User from '@/views/user/User';
import UserList from '@/views/user/UserList';
import { dashLayout } from '../layout';
import { isLoggedIn } from '../guards';

export default [
  {
    path: '/user/gestor',
    name: 'UserGestor',
    components: {
      default: User,
      ...dashLayout,
    },
    children: [
      {
        path: 'list/',
        name: 'UserList',
        components: {
          default: UserList,
        },
        beforeEnter: isLoggedIn,
      },
    ],
  },
];



// WEBPACK FOOTER //
// ./src/router/modules/user-gestor.js